import './CalendarIcon.less';

import moment from 'moment';
import React from 'react';

export default function CalendarIcon({ fake }: { fake: boolean }) {
    return (
        <div className="calendar-icon">
            <div className="top">
                <span className="point first" />
                <span className="point sec" />
            </div>
            <div className="bottom">
                <span className="point first" />
                <span className="point sec" />
            </div>
            <div className="separator" />
            {fake ? null : <div className="date day">{moment().format('DD')}</div>}
        </div>
    );
}
